<template>
  <div class="box">
    <div class="top_box">
      <div class="SalesVolume">
        <p>{{item.timeRange[0]}}</p>
        <span>开始日期</span>
      </div>
      <div class="sales">
        <span>起始总销量 {{ item.initSalesVolume }}</span>
        <div class="border"></div>
        <span>截止总销量 {{item.finalSalesVolume}}</span>
      </div>
      <div class="SalesVolume">
        <p>{{item.timeRange[1]}}</p>
        <span>截止日期</span>
      </div>
    </div>
    <div class="sales_box">
      <div class="sales_1">
        <span>销量净增</span>
        <p>{{item.salesAdd}}</p>
      </div>
      <div class="sales_1">
        <span>预估销售额</span>
        <p style="color: #ff5000;">¥{{ item.sales }}</p>
      </div>
    </div>
    <div class="list_box">
      <div class="top_box">
        <div class="left">{{item.anchorCount}}个直播达人</div>
        <div class="avatar">
          <img :src="val.avatar" alt="" v-for="val in item.anchorList" style="border-radius: 50%;" @click="to(`/anchor/${val.id}`)">
          <div class="image" style="border-radius: 50%;"  @click="tabLink('anchor')" v-if="item.anchorList.length === 3">
            <img src="https://s6.bihukankan.com/img/1697191270326.svg" style="width: 20px;height: 20px;display: block;margin-right: 0" alt="">
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="anchor_list_item_more" viewBox="0 0 20 6" fill="none">-->
<!--              <circle cx="5" cy="3" r="1" fill="#CFCFCF"/>-->
<!--              <circle cx="10" cy="3" r="1" fill="#CFCFCF"/>-->
<!--              <circle cx="15" cy="3" r="1" fill="#CFCFCF"/>-->
<!--            </svg>-->
          </div>
        </div>
      </div>
      <div class="bottom_box">
        共{{item.liveCount}}场直播，累计时长{{item.duration}}，触达观众{{item.uv}}人次
      </div>
    </div>
    <div class="list_box">
      <div class="top_box">
        <div class="left">
         {{ item.commodityCount }}个直播商品</div>
        <div class="avatar">
          <img :src="val.imageUrl" alt="" v-for="val in item.commodityList" style="border-radius: 15%;" @click="to(`/goods/${val.itemId}`)">
          <div class="image" style="border-radius: 15%;" @click="tabLink('commodity')" v-if="item.commodityList.length">
            <img src="https://s6.bihukankan.com/img/1697191270326.svg" style="width: 20px;height: 20px;display: block;margin-right: 0" alt="">
          </div>
        </div>
      </div>
      <div class="bottom_box">
       涵盖{{item.brandCount}}品牌，{{item.brandCount}}个新品，商品均价¥{{item.commodityAvgPrice}}
      </div>
    </div>
    <div class="salesCount">
      <p>场次累计销量 {{ item.commoditysales }} 场次累计销售额 ¥{{item.commoditysalesVolume}}</p>
      <span>(仅为直播期间对数据统计，不包含下播后数据变动）</span>
    </div>
    <div class="list_box">
      <div class="top_box">
        <div class="left">{{item.opusCount}}个带货视频</div>
        <div class="avatar">
          <img :src="val.cover" alt="" v-for="val in item.opusList" style="border-radius: 15%;">
          <div class="image" style="border-radius: 15%;"  @click="tabLink('delivery')" v-if="item.opusList.length">
            <img src="https://s6.bihukankan.com/img/1697191270326.svg" style="width: 20px;height: 20px;display: block;margin-right: 0" alt="">
          </div>
        </div>
      </div>
      <div class="bottom_box">
        共有{{item.opusanchorCount}}个达人发布，关联{{item.opuscommodityCount}}个商品，总播放量{{item.opusviews}}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
    props:{
        info:Object
    },
  data() {
    return {};
  },
  methods: {
    isNum(str) {
      return !isNaN(str) && str === 0 ? '0' : str
    },
    tabLink(val) {
      this.$emit('tabLink',val)
    },
   Time(tiem) {
    if(!tiem) {
        return '-'
    }
      const HH =Math.floor(tiem / 3600)
      const MM = Math.floor((tiem % 3600) / 60)
      return `${HH ?HH + '时' : ''}${MM}分`
    },
    to(url) {
      this.$router.push({path:url})
    }
  },
  computed:{
    item() {
        return {
            ...this.info,
            timeRange: this.info?.timeRange ? [moment(this.info?.timeRange[0] * 1000).format('MM-DD'),moment(this.info?.timeRange[1] * 1000).format('MM-DD')] : ['',''],//起始截止日期
            initSalesVolume: this.isNum(this.info?.initSalesVolume)  ? this.$retainWan(this.info?.initSalesVolume) : '-',//起始销量
            finalSalesVolume:this.isNum(this.info?.finalSalesVolume) ? this.$retainWan(this.info?.finalSalesVolume) : '-',//截止销量
            sales: this.isNum(this.info?.sales) ? this.$retainWan(this.info?.sales) : '-',//预估销售额
            salesAdd:this.isNum(this.info?.finalSalesVolume) ? this.$retainWan(this.info?.finalSalesVolume - this.info?.initSalesVolume) : '-',//销量净增
            anchorCount: this.isNum(this.info?.liveStatistic?.anchorCount) || '-',//关联达人数量
            uv:this.isNum(this.info?.liveStatistic?.uv) ? this.$retainWan(this.info?.liveStatistic?.uv) : '-',//uv
            duration:this.Time(this.info?.liveStatistic?.duration),//直播总时长
            liveCount: this.isNum(this.info?.liveStatistic?.liveCount) || '-',//直播场次›
            commodityCount: this.isNum(this.info?.liveStatistic?.commodityCount) || '-',//关联直播商品数量
            brandCount: this.isNum(this.info?.liveStatistic?.brandCount) || '-',//关联直播商品涵盖品牌数量
            newCommodityCount: this.isNum(this.info?.liveStatistic?.newCommodityCount) || '-',//关联直播商品新品数量
            commodityAvgPrice: this.isNum(this.info?.liveStatistic?.commodityAvgPrice) || '-',//关联直播商品新品数量
            commoditysales:this.isNum(this.info?.liveStatistic?.sales) ? this.$retainWan(this.info?.liveStatistic?.sales) : '',//累计销量
            commoditysalesVolume:this.isNum(this.info?.liveStatistic?.salesVolume) ? this.$retainWan(this.info?.liveStatistic?.salesVolume) : '-',//关累计销售额
            opusCount:this.isNum(this.info?.opusStatistic?.opusCount) || '-',//关联带货视频数量
            opusanchorCount: this.isNum(this.info?.opusStatistic?.anchorCount) || '-',//关联带货视频达人
            opuscommodityCount: this.isNum(this.info?.opusStatistic?.commodityCount) || '-',//关联带货视频商品
            opusviews: this.isNum(this.info?.opusStatistic?.views) ?  this.$retainWan(this.info?.opusStatistic?.views) : '-',//关联带货视频播放量
            anchorList: this.info?.anchor?.length > 3 ? this.info?.anchor.slice(0,3) : this.info?.anchor,//达人直播列表
            commodityList: this.info?.commodity?.length > 3 ? this.info?.commodity.slice(0,3) : this.info?.commodity,//直播商品列表
            opusList: this.info?.opus?.length > 3 ? this.info?.opus.slice(0,3) : this.info?.opus,//关联视频列表
        }
    }
  },
};
</script>

<style scoped lang="less">
.box {
  background-color: #fff;
  padding: 24px 12px 8px 12px;
  margin-bottom: 12px;
  .top_box {
    display: flex;
    height: 52px;
    .SalesVolume {
      width: 80px;
      height: 52px;
      border-radius: 8px;
      border: 1px solid rgba(40, 119, 255, 0.6);
      background: rgba(40, 119, 255, 0.04);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      span {
        color: #696d75;
        text-align: center;
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      p {
        color: var(--unnamed, #252e39);
        text-align: center;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }
    }
    .sales {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      span {
        color: var(--unnamed, #8e9aae);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .border {
        width: 100%;
        border-bottom: 2px dashed rgba(40, 119, 255, 0.6);
      }
    }
  }
  .sales_box {
    display: flex;
    .sales_1 {
      flex: 1;
      display: flex;
      margin: 16px 0 12px 0;
      span {
        color: var(--unnamed, #8e9aae);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 0.62rem;
        margin-right: 8px;
      }
      p {
        color: var(--unnamed, #252e39);
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }

  .list_box {
    width: 351px;
    height: 86px;
    padding: 20px 0px 16px 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(168, 178, 197, 0.08),
      0px 0px 8px 0px rgba(0, 0, 0, 0.04);
    margin-bottom: 12px;
    .top_box {
      display: flex;
      margin-bottom: 12px;
      height: 30px;
      border-radius: 50%;
      justify-content: space-between;
      align-items: center;
      .left {
        color: #141b27;
        text-align: center;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
      }
      .avatar {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
        .image {
          width: 30px;
          height: 30px;
          margin-right: 8px;
          border: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .bottom_box {
      color: #8e9aae;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .salesCount {
    margin: 14px 0;
    p {
      color: #252e39;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 4px;
    }
    span {
      color: #8e9aae;
      text-align: center;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 12px; /* 100% */
    }
  }
}
</style>
